<template>
  <AuthLayout
    mode="register"
    sidebar-title="Create your account"
    sidebar-text="Choose who you'd like to register with RemoniHealth."
    :support-phone="supportPhone"
    title="Registration"
    subtitle="Patients receive an invitation via email or text message when prescribed by their doctor."
    :card="false"
  >
      <div class="auth-register__roles" role="group" aria-label="Registration type">
        <AuthRoleOption
          title="Practice"
        description="Register your practice and stay close to your patients."
        icon="practice"
        :active="selected === 'practice'"
          @select="select('practice')"
        />
        <AuthRoleOption
        v-if="showPatientRegistration"
        title="Patient"
        description="Patient registration is currently unavailable."
        icon="user"
          disabled
        />
    </div>

    <div class="auth-login__actions">
      <AuthButton :disabled="!selected" @click="handleContinue">
        Continue
      </AuthButton>
    </div>

    <template #footer>
      <p class="auth-login__signup-hint">
        Already have an account?
        <a :href="loginUrl" class="auth-login__link auth-login__link--plain">Sign in</a>
      </p>
    </template>
  </AuthLayout>
</template>

<script setup>
import { ref } from 'vue'
import AuthLayout from '../../shared/components/AuthLayout.vue'
import AuthButton from '../../shared/components/AuthButton.vue'
import AuthRoleOption from '../../shared/components/AuthRoleOption.vue'

const props = defineProps({
  supportPhone: { type: String, default: '815-908-2020' },
  loginUrl:     { type: String, default: '/login' },
  practiceUrl:  { type: String, default: '/register-practice' },
  patientUrl:   { type: String, default: '/register-patient' },
})

const emit = defineEmits(['select'])

const showPatientRegistration = false
const selected = ref(null)

const select = (role) => {
  selected.value = role
}

const handleContinue = () => {
  if (!selected.value) return
  window.location.href = props.practiceUrl
}
</script>
